"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./SFSelect.css");
var SFSelect = function (props) {
    return (react_1.default.createElement("div", { className: "select" },
        react_1.default.createElement("select", { role: "select", onChange: props.onChange, defaultValue: props.selectedOption ? props.selectedOption.value : '' },
            props.defaultText ? (react_1.default.createElement("option", { value: "", disabled: true }, props.defaultText)) : (react_1.default.createElement("option", { value: "", disabled: true }, "Make a selection")),
            props.options.map(function (o) {
                return (react_1.default.createElement("option", { value: o.value, key: o.value, disabled: o.disabled }, o.text));
            })),
        react_1.default.createElement("div", { className: "select_arrow" })));
};
exports.default = SFSelect;
